export default __webpack_public_path__ + "static/Calibre-RegularItalic-5f875bd7b669f1e11b622d4d6d71b5b0.woff2";